import { useEffect } from 'react'

import { useUnit } from 'effector-react'
import { useQueryClient } from 'react-query'

import {
  $chats,
  $chatsMap,
  $fanId,
  getChatsDetailsFx,
  getChatsFx,
} from '@/models/chattingUI/chats/chats.ts'
import { $creatorId } from '@/models/creators.ts'

import { newTab } from '../state/tabs-provider'
import type { ChattingTab } from '../types'

interface Options {
  tabs: ChattingTab[]
}

export const useMissingChats = ({ tabs }: Options) => {
  const creatorId = useUnit($creatorId)
  const fanId = useUnit($fanId)
  const queryClient = useQueryClient()
  const chats = useUnit($chats)
  const chatsMap = useUnit($chatsMap)
  const isChatsLoading = useUnit(getChatsFx.pending)
  const isChatDetailsLoading = useUnit(getChatsDetailsFx.pending)

  useEffect(() => {
    if (!creatorId) return

    // wait for the first load of chats
    if (!chats.length && isChatsLoading) return

    tabs.forEach((tab) => {
      // ignore default tab and active fan, because it will be requested from effector layer
      if (!fanId || tab.fanId === newTab.fanId || tab.fanId === fanId) {
        return
      }

      const isChatFoundInList = chats.some((chat) => chat.id === tab.fanId)

      // do nothing if the chat is already there or requested
      if (isChatFoundInList || !!chatsMap[tab.fanId] || isChatDetailsLoading)
        return

      getChatsDetailsFx(tab.fanId)
    })
  }, [
    creatorId,
    tabs,
    chats,
    isChatsLoading,
    queryClient,
    isChatDetailsLoading,
    chatsMap,
    fanId,
  ])
}
